module.exports = __webpack_public_path__ + "img/my-menu-items-dish-sm.90a13de8.jpg";